export default function roomGroupEventListener(room) {
  return store => {
    room.addEventListeners({
      room_group_setRoomGroup: data => {
        let { roomGroupList } = data.data

        store.commit('roomGroup/SET_ROOM_GROUP', roomGroupList)
      },
      room_group_resetRoomUserGroup: data => {
        store.commit('roomGroup/RESET_ROOM_GROUP')
      },
      room_group_removeRoomGroup: data => {
        store.commit('roomGroup/RESET_ROOM_GROUP', data.data)
      },
      room_group_changeRoomGroup: data => {
        store.commit('roomGroup/CHANGE_ROOM_GROUP', data.data)
      },
      room_group_message: data => {
        const text = data.data.text

        store.commit('common/SET_NOTIFY', {
          title: '대표FT 메세지',
          text,
          isClose: true,
        })
      },
      room_group_changeMode: e => {
        store.commit('roomGroup/changeMode', {roomGroup: e.data})
      },
      room_user_enter: data => {
        store.commit('roomGroup/SET_NEW_USER')
      },
      room_user_leave: data => {
        store.commit('roomGroup/SET_NEW_USER')
      },
      room_set_newUser: data => {
        store.commit('roomGroup/SET_NEW_USER')
      },
      set_loading_group_mode: data => {
        store.commit('roomGroup/SET_LOADING_GROUP_MODE', data.data)
      },
      room_group_set_speaker: data => {
        store.commit('roomGroup/CHANGE_GROUP_SPEAKER', data.data);
      },
      room_group_set_mic: data => {
        store.commit('roomGroup/CHANGE_GROUP_MIC', data.data);
      },
      room_group_changeLayoutType: data => {
        store.commit('roomGroup/CHANGE_VIDEO_LAYOUT_TYPE', data.data)
      }
    });
  }
}